import { getQuotationTemplates } from '../../../../services/api/miles/miles-services';

export const setFinancialProductList = async () => {
  const offers = await getQuotationTemplates();
  return offers?.financialProduct?.offers?.map((offer: any) => ({
    value: offer.milesTemplateId,
    label: offer.productDescription,
  }));
};
